import { Icon } from '@chakra-ui/react';

export const VideoFilmIcon = (props: any) => (
  <Icon aria-label="video film icon" viewBox="1 1 16 16" {...props}>
    <path
      d="m16.5 2.25v13.5h-15v-13.5zm-13.5 10.5v1.5h1.5v-1.5zm9-9h-6v10.5h6zm3 9h-1.5v1.5h1.5zm0-3h-1.5v1.5h1.5zm-7.5-3 3.75 2.25-3.75 2.25zm7.5 0h-1.5v1.5h1.5zm-10.5 0h-1.5v1.5h1.5zm10.5-3h-1.5v1.5h1.5zm-10.5 0h-1.5v1.5h1.5zm-1.5 7.5h1.5v-1.5h-1.5z"
      fill="currentColor"
    />
  </Icon>
);
